import * as React from "react";
import AssistantSidebar from "ai/sidebar/AssistantSidebar";
import WidgetSummaryActionComponent from "ai/widget-summary/WidgetSummaryActionComponent";
import { AssistantSidebarProvider } from "ai/sidebar/AssistantSidebarContext";
import AppConfig from "util/AppConfig";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import MessagesWidget from "views/logic/widgets/MessagesWidget";
import MessagesWidgetSummaryActionComponent from "ai/widget-summary/MessagesWidgetSummaryActionComponent";
import AddContextAction from "ai/context-field/AddContextAction";
import useWidgetSummaryFeatureToggle from "ai/widget-summary/useWidgetSummaryFeatureToggle";
import SelectedMessagesSummaryBulkAction from "ai/widget-summary/SelectedMessagesSummaryBulkAction";
const WidgetSummaryWithFeatureToggle = (props) => {
  const featureToggle = useWidgetSummaryFeatureToggle();
  return featureToggle.enabled ? /* @__PURE__ */ React.createElement(WidgetSummaryActionComponent, { ...props }) : null;
};
const WidgetSummaryAction = {
  type: "widget-summary-action",
  position: "menu",
  component: WidgetSummaryWithFeatureToggle,
  isHidden: ({ type }) => type !== AggregationWidget.type
};
const MessagesWidgetSummaryWithFeatureToggle = (props) => {
  const featureToggle = useWidgetSummaryFeatureToggle();
  return featureToggle.enabled ? /* @__PURE__ */ React.createElement(MessagesWidgetSummaryActionComponent, { ...props }) : null;
};
const MessagesWidgetSummaryAction = {
  type: "messages-widget-summary-action",
  position: "menu",
  component: MessagesWidgetSummaryWithFeatureToggle,
  isHidden: ({ type }) => type !== MessagesWidget.type
};
const useSelectedMessagesSummaryCondition = () => useWidgetSummaryFeatureToggle().enabled;
const pluginExports = AppConfig.isFeatureEnabled("widget_summary") ? {
  "views.elements.aside": [AssistantSidebar],
  "views.widgets.actions": [WidgetSummaryAction, MessagesWidgetSummaryAction, AddContextAction],
  "views.components.widgets.messageTable.messageBulkActions": [
    {
      component: SelectedMessagesSummaryBulkAction,
      key: "widget-summary",
      useCondition: useSelectedMessagesSummaryCondition
    }
  ],
  "globalContextProviders": [AssistantSidebarProvider]
} : {};
export default pluginExports;
